import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import HomePage from "@/pages/HomePage";
import PrivacyPage from "@/pages/PrivacyPage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    window.scrollTo(0, 0);
    lenis?.scrollTo(0, { immediate: true });
  }, [pathname, lenis]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09 }}>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tietosuoja" element={<PrivacyPage />} />
        </Routes>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
